import { ensureOrgContext } from "@/lib/utils/org-context-guard";
import {
  getOrganizationType,
  isOnboardingCompleted,
} from "@/lib/utils/organization";
import { createFileRoute, redirect } from "@tanstack/react-router";
import type { OrgRouteContext } from "./route";

export const Route = createFileRoute("/(org)/o/$orgSlug/")({
  beforeLoad: ({ context, params }) => {
    const { organization } = context as OrgRouteContext;
    if (
      !ensureOrgContext(organization, "(org)/o.$orgSlug/index.tsx#beforeLoad", {
        orgSlug: params.orgSlug,
      })
    ) {
      throw redirect({ to: "/", search: { error: "organization_not_found" } });
    }
    const orgType = getOrganizationType(organization.metadata);

    // Creators who haven't completed onboarding go to the onboarding page
    if (
      orgType === "creator" &&
      !isOnboardingCompleted(organization.metadata)
    ) {
      throw redirect({
        to: "/o/$orgSlug/onboarding",
        params: { orgSlug: params.orgSlug },
      });
    }

    throw redirect({
      to: "/o/$orgSlug/dashboard",
      params: { orgSlug: params.orgSlug },
    });
  },
});
